var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import omit from 'lodash/omit';
import React from 'react';
import EdsDivider from '@hedtech/react-design-system/core/es/Divider';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    noMarginBottom: {
        marginBottom: '0rem'
    },
    noMarginTop: {
        marginTop: '0rem'
    },
    root: {}
});
const Divider = (props) => {
    const { classes, noMarginBottom, noMarginTop } = props, rest = __rest(props, ["classes", "noMarginBottom", "noMarginTop"]);
    const classOverrides = omit(classes, ['noMarginBottom', 'noMarginTop']);
    if (noMarginBottom) {
        classOverrides.root = classnames(classOverrides.root, classes.noMarginBottom);
    }
    if (noMarginTop) {
        classOverrides.root = classnames(classOverrides.root, classes.noMarginTop);
    }
    return (React.createElement(EdsDivider, Object.assign({ classes: classOverrides }, rest)));
};
export default withStyles(styles)(Divider);
